import { ArrowRight, MapPin, Navigation, Crosshair } from "lucide-react";
import { t } from "@/lib/i18n";
import { formatKm } from "@/lib/categories";

const LiveCard = ({ geo, nearest }) => (
  <div data-testid="hero-live-card" className="hg-rise relative w-full max-w-sm rounded-3xl border border-ac-line bg-ac-surface p-6 backdrop-blur-xl" style={{ animationDelay: "250ms" }}>
    <p className="ac-eyebrow flex items-center gap-2"><span className="h-1.5 w-1.5 animate-pulse rounded-full bg-[color:var(--ac-eyebrow)]" /> Live</p>
    <div className="mt-4 space-y-4">
      <div data-testid="hero-location" className="flex gap-3">
        <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-ac-primary" />
        <div className="min-w-0"><p className="text-[11px] uppercase tracking-[0.16em] text-ac-faint">{t("hero.zone")}</p><p className="truncate font-semibold text-ac-ink">{geo.isReal ? geo.place : t("hero.cdmx")}</p></div>
      </div>
      <div data-testid="hero-nearest" className="flex gap-3">
        <Navigation className="mt-0.5 h-4 w-4 shrink-0 text-ac-primary" />
        <div className="min-w-0"><p className="text-[11px] uppercase tracking-[0.16em] text-ac-faint">{t("hero.nearest")}</p><p className="line-clamp-2 font-semibold text-ac-ink">{nearest ? `${nearest.name} · ${formatKm(nearest.distance_km)}` : "—"}</p></div>
      </div>
      <div className="flex gap-3 border-t border-ac-line pt-4 font-mono text-xs text-ac-muted">
        <Crosshair className="h-4 w-4 shrink-0 text-[color:var(--ac-eyebrow)]" />
        {geo.position[0].toFixed(4)}, {geo.position[1].toFixed(4)}
      </div>
    </div>
  </div>
);

export const HeroSection = ({ geo, nearest, onOpenChat }) => (
  <section id="inicio" data-testid="hero-section" className="relative overflow-hidden">
    <span className="ac-rings -right-40 -top-40 h-[720px] w-[720px]" />
    <span className="ac-rings -bottom-64 left-1/3 h-[520px] w-[520px] opacity-60" style={{ animationDelay: "-6s" }} />
    <div className="relative mx-auto max-w-[1300px] px-4 pb-24 pt-16 sm:px-8 lg:pb-32 lg:pt-24">
      <p className="ac-eyebrow hg-rise">{t("hero.eyebrow")}</p>
      <p className="ac-eyebrow hg-rise mt-1 !tracking-[0.12em] !text-ac-muted" style={{ animationDelay: "60ms" }}>{geo.isReal ? geo.place : t("hero.cdmx")} · 24/7</p>
      <h1 data-testid="hero-wordmark" className="font-mark hg-rise mt-8 text-[clamp(2.2rem,8.6vw,7.5rem)] font-extrabold uppercase leading-[0.85] text-ac-ink" style={{ animationDelay: "120ms" }}>
        Aclara<span className="ac-grad-text">te</span>
        <span className="ml-2 align-top font-wide text-[0.3em] font-light normal-case text-ac-muted">MX</span>
      </h1>
      <div className="mt-10 grid items-end gap-12 lg:grid-cols-[1.5fr_1fr]">
        <div className="min-w-0">
          <p className="hg-rise max-w-2xl font-wide text-xl font-light leading-snug text-ac-text sm:text-2xl lg:text-3xl" style={{ animationDelay: "180ms" }}>{t("hero.tagline")}</p>
          <p className="hg-rise mt-4 max-w-xl text-base text-ac-muted" style={{ animationDelay: "220ms" }}>{t("hero.sub")}</p>
          <div className="hg-rise mt-10 flex flex-wrap gap-3" style={{ animationDelay: "260ms" }}>
            <a href="#mapa-seccion" data-testid="hero-cta-map" className="ac-pill ac-pill-solid">{t("hero.cta1")} <ArrowRight className="h-4 w-4" /></a>
            <button data-testid="hero-cta-clara" onClick={onOpenChat} className="ac-pill ac-pill-ghost">{t("nav.cta")}</button>
          </div>
        </div>
        <div className="flex min-w-0 justify-center lg:justify-end"><LiveCard geo={geo} nearest={nearest} /></div>
      </div>
    </div>
  </section>
);
